export function ComplianceBadge({ c, testId }) {
  if (!c) return null;
  const fail = !c.safe_pass_ok;
  const cls = c.compliant ? "bg-emerald-100 text-emerald-700" : fail ? "bg-rose-100 text-rose-700" : "bg-amber-100 text-amber-800";
  const suffix = fail ? " · Safe Pass" : c.compliant ? "" : " · incomplete";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${cls}`}>
      {c.pct}%{suffix}
    </span>
  );
}
